import { render, staticRenderFns } from "./s_AllInvitations.vue?vue&type=template&id=12be1b74&scoped=true&"
import script from "./s_AllInvitations.vue?vue&type=script&lang=js&"
export * from "./s_AllInvitations.vue?vue&type=script&lang=js&"
import style0 from "./s_AllInvitations.vue?vue&type=style&index=0&id=12be1b74&prod&lang=css&"
import style1 from "./s_AllInvitations.vue?vue&type=style&index=1&id=12be1b74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be1b74",
  null
  
)

export default component.exports